import React, {useContext, useEffect, useState, createRef, useRef} from 'react'
import {
  Accordion,
  AccordionContext,
  Card,
  Col,
  useAccordionToggle,
} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import Modal from 'react-modal'

import Element from '../../Components/Element'
import CustomSelect from '../../Components/Forms/CustomSelect'
import {changeInitialLoading} from '../../redux/modules/app'
import {getNewReleases} from '../../Utils/api'
import {getMonthByIndex} from '../../Utils/tools'
import {addEventNameWithParams, cleanText, logEvent} from '../../Utils/utils'
import productImg from '../../assets/img/prescription.png'
import loadingYapp from '../../assets/img/yapp_loading.gif'

const _get = require('lodash/get')
const _orderBy = require('lodash/orderBy')

function HeaderToggle({title, eventKey, callback}) {
  const currentEventKey = useContext(AccordionContext)
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  )
  const isCurrentEventKey = currentEventKey === eventKey

  return (
    <div className="d-flex " onClick={() => decoratedOnClick()}>
      <div className="d-flex align-items-center w-100">
        <p className="title-primary--xxl-regular">{title}</p>
      </div>
      <div className="d-flex align-items-center">
        <i
          className={`icon-chevron-down color-theme ${
            isCurrentEventKey ? 'icon-up icon-reverse' : ''
          }`}></i>
      </div>
    </div>
  )
}

function NewDrugs(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const [showFiltered, setShowFiltered] = useState(false)
  const [optionsData, setOptionsData] = useState([])
  const [filterData, setFilterData] = useState([])
  const [modal, setModal] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    dispatch(changeInitialLoading(true))
    getNewReleases()
      .then((resp) => {
        let category = resp?.data?.category.map((item) => {
          return {
            label: item?.category_name,
            value: item?.id,
          }
        })
        setOptionsData([...[{label: 'todas', value: null}], ...category])

        let data = resp?.data?.result

        if (data) {
          data = data.map((item) => {
            return {
              ...item,
              detail: _orderBy(item.detail, 'month', 'desc'),
            }
          })

          setData(data)
        }
        dispatch(changeInitialLoading(false))
      })
      .catch((err) => {
        console.log(err)
        dispatch(changeInitialLoading(false))
      })
    return () => {}
  }, [])

  function goBack() {
    history.goBack()
  }

  function goToProductDetail(product, year) {
    if (![undefined, null].includes(year)) {
      addEventNameWithParams('new_releases_selected_product', {
        product_name: product?.name,
        product_id: product?.id,
        year: year,
      })
    }

    if (product.vademecum_id) {
      history.push(`/product/detail/${product.id}`, {
        product_id: product.id,
        product: {
          ...product,
          product_id: product.id,
          product_name: product?.name,
        },
        external_vademecum: false,
      })
    } else {
      setModal(true)
    }
  }

  function applyFilter(value) {
    let filterData = []

    if (value?.value === null) {
      return clearFilter()
    }

    setLoading(true)
    setShowFiltered(false)
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const element = data[key]
        let filtered = element?.detail.map((item) => {
          let filteredProducts = item?.detail.filter(
            (itemProduct) => itemProduct?.product?.category_id === value?.value,
          )

          if (filteredProducts?.length > 0) return filteredProducts
        })

        filtered = filtered.filter((item) => item !== undefined)
        filterData = [...filterData, ...filtered]
      }
    }

    setFilterData(_get(filterData, '[0]'))
    setShowFiltered(true)
    setLoading(false)
  }

  const clearFilter = () => {
    setShowFiltered(false)
    setFilterData([])
  }
  const itemsRef = useRef([])

  const slide = (shift, index, year) => {
    let nav = document.getElementById('nav' + year + (index + 1))
    nav.scrollLeft += shift
  }
  return (
    <>
      <div className="py-3 px-3">
        <div className="content-responsive mx-auto d-flex justify-content-between">
          <div className="breadcrumbs c-pointer" onClick={goBack}>
            <a className="d-flex align-items-center">
              <i className="icon-chevron-right icon-reverse"></i>
            </a>
            <span className="title-primary--regular line-14">Volver</span>
          </div>
        </div>
      </div>
      <div className="wrapper-location">
        <div className="py-3 h-100 content-new-drugs d-flex flex-column">
          <h3 className="title-primary--xxl-regular mb-2">
            Nuevos lanzamientos
          </h3>
          <div className="content-filter-new-drugs">
            <CustomSelect options={optionsData} onChange={applyFilter} />
          </div>
          {loading && (
            <img
              src={loadingYapp}
              alt="loading"
              className="loading-yapp--alternative t-0"
            />
          )}

          <Element show={!loading}>
            {showFiltered ? (
              <div className="content-new-drugs-filter m-0">
                {filterData.map((detail, index) => (
                  <div
                    id={`gtm-weapp-new-drugs-produt-${index}`}
                    className="product-detail c-pointer"
                    key={index}
                    onClick={() => goToProductDetail(detail.product)}>
                    <div className="product-detail-content-img d-flex justify-content-center text-center">
                      <img
                        src={
                          detail?.product?.image
                            ? detail?.product?.image
                            : productImg
                        }
                        className="product-detail-img mx-auto"
                        alt="Paracetamol 100 mg/mL x 15 mL"
                      />
                    </div>
                    <div className="content-txt">
                      <p className="title-primary--xl ">
                        {cleanText(detail?.product?.name)}
                      </p>
                      <p className="txt-paragraph--small line-14">
                        {detail?.product?.composition}
                      </p>
                      <p className="txt-paragraph--small line-14">
                        {detail?.product?.presentation}
                      </p>
                      <p className="txt-paragraph--small line-14">
                        {detail?.laboratory}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {data.length > 0 && <hr className="hr--lilac toggle-default" />}
                <div className="content-card-info-pro-new-release">
                  <div className="toggle-default line-lilac mb-4">
                    <Accordion>
                      {data.map((item, key) => (
                        <Card key={key}>
                          <Card.Header>
                            <Accordion.Toggle
                              as={Col}
                              className=""
                              variant="link"
                              eventKey={`${key}`}>
                              <HeaderToggle
                                title={item.year}
                                eventKey={`${key}`}
                              />
                            </Accordion.Toggle>
                          </Card.Header>
                          <Accordion.Collapse eventKey={`${key}`}>
                            <Card.Body className="inner-padding">
                              {item?.detail.map((itemMonth, firtsKey) => {
                                return (
                                  <div
                                    ref={(e) => (itemsRef.current[key] = e)}
                                    className=""
                                    key={firtsKey}>
                                    <div className="d-flex justify-content-between w-100 mb-2">
                                      <p
                                        className={`title-primary--regular mb-2 ml-20  ${
                                          firtsKey !== 0 && 'mt-2 mt-md-3 '
                                        }`}>
                                        {getMonthByIndex(itemMonth.month)}
                                      </p>
                                      <div className="carousel-nav">
                                        <button
                                          onClick={() =>
                                            slide(-140, firtsKey, item?.year)
                                          }
                                          className="carousel-prev ">
                                          <i className="icon-chevron-left notification-icon "></i>
                                        </button>
                                        <button
                                          onClick={() =>
                                            slide(+140, firtsKey, item?.year)
                                          }
                                          className="carousel-next">
                                          <i className="icon-chevron-right notification-icon"></i>
                                        </button>
                                      </div>
                                    </div>

                                    <div
                                      className={'content-new-drugs'}
                                      id={`nav${item?.year}${firtsKey + 1}`}>
                                      {itemMonth?.detail.map(
                                        (detail, index) => (
                                          <div
                                            id={`gtm-weapp-new-drugs-produt-${index}`}
                                            className="product-detail c-pointer"
                                            key={index}
                                            onClick={() =>
                                              goToProductDetail(
                                                detail?.product,
                                                item.year,
                                              )
                                            }>
                                            <div className="product-detail-content-img d-flex justify-content-center text-center">
                                              <img
                                                src={
                                                  detail?.product?.image
                                                    ? detail?.product?.image
                                                    : productImg
                                                }
                                                className="product-detail-img mx-auto"
                                                alt="Paracetamol 100 mg/mL x 15 mL"
                                              />
                                            </div>
                                            <div className="content-txt">
                                              <p className="title-primary--xl ">
                                                {cleanText(
                                                  detail?.product?.name,
                                                )}
                                              </p>
                                              <p className="txt-paragraph--small line-14">
                                                {detail?.product?.composition}
                                              </p>
                                              <p className="txt-paragraph--small line-14">
                                                {detail?.product?.presentation}
                                              </p>
                                              <p className="txt-paragraph--small line-14">
                                                {detail?.laboratory}
                                              </p>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                )
                              })}
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      ))}
                    </Accordion>
                  </div>
                </div>
              </>
            )}
          </Element>
        </div>
      </div>
      <Modal
        isOpen={modal}
        onAfterOpen={null}
        onRequestClose={() => null}
        className="modal-custom"
        overlayClassName="modal-custom-bg"
        contentLabel="ModalSendMail"
        ariaHideApp={false}>
        <button className="btn-circle-close" onClick={() => setModal(false)}>
          <i className="icon-close"></i>
        </button>
        <div>
          <p className="title-primary--xxl">Próximamente</p>
        </div>
      </Modal>
    </>
  )
}

export default NewDrugs
